<template>
  <fin-time-and-tags
    :dark="darkTags"
    :datetime="post.date ? post.date : meta.firstPublicationDate"
    :spacing="spacing"
    :tag="tag"
    :tagTooltip="`Zeige alle Einträge zur Kategorie ${tag}`"
    :timeColor="timeColor"
    refresh
    v-bind="target">
    <template #prependTag>
      <v-icon
        v-if="groupPriceModel && groupPriceModel.id !== 'DEVELOPER' && post[groupPriceModel.id.toLowerCase()] === false"
        :color="$finColors.accentRed"
        @click.stop="clickLockedEntry()">
        mdi-lock
      </v-icon>

      <fin-tag class="d-inline mr-1" :dark="darkTags" v-if="showVideoIcon">
        <v-icon :dark="darkTags">mdi-video</v-icon>
      </fin-tag>
    </template>
  </fin-time-and-tags>
</template>

<script>
import {mapGetters} from "vuex"
import {EventBus} from "@/plugins/fincraft"
import {PRICEMODEL_FEATURE_IDS, PRICEMODEL_FEATURE_RESTRICTIONS} from "@/js/finPriceModel"

export default {
  name: 'FinPostTime',
  props: {
    /**
     *  Post object from prismic
     */
    post: {
      required: true,
      type: Object,
    },
    /**
     * Applies the dark theme variant to the tag.
     */
    darkTags: {
      type: Boolean,
    },
    /**
     * The color of the time
     */
    timeColor: {
      type: String,
      default: 'var(--cool-grey)',
    },
    /**
     *  add spacing between time and tag
     */
    spacing: {
      type: Boolean,
    },
    postType: {
      type: String,
      default: 'academyTag'
    }
  },
  computed: {
    ...mapGetters('auth', ['userId', 'groupPriceModel']),
    meta() {
      // eslint-disable-next-line no-underscore-dangle
      return this.post._meta
    },
    tag() {
      if (this.meta.tags && this.meta.tags.length > 0) {
        return this.meta.tags[0]
      }
      return null
    },
    target() {
      const res = {name: this.postType, params: {tagId: this.tag}}
      return {
        to: res,
      }
    },
    showVideoIcon() {
      return this.post.video?.embed_url
    },
  },
  methods: {
    clickLockedEntry() {
      EventBus.$emit('showSubscriptionPopup', PRICEMODEL_FEATURE_IDS.ACADEMY.id, PRICEMODEL_FEATURE_RESTRICTIONS.QUALITY)
    }
  }
}
</script>

<style lang="scss" scoped>
.time-and-tags {
  font-family: Gilroy !important;
  font-size: 12px;
  font-weight: 600;
  font-stretch: normal;
  font-style: normal;
}
</style>
